import Head from 'next/head';
import { ConsentModal } from '../ConsentModal/ConsentModal';
import { Footer } from '../Footer/Footer';
import { MainNavigation } from '../Navigation/MainNavigation/MainNavigation';
import { ISiteSubNavLinkItem } from '../Navigation/SiteSubNavigation/helpers/siteSubNavLinks';
import { SiteSubNavigation } from '../Navigation/SiteSubNavigation/SiteSubNavigation';
import { StickyBannerGetApp } from '../StickyBottomBanner/StickyBannerGetApp/StickyBannerGetApp';
import { AppRedirectModal } from '../AppRedirectModal/AppRedirectModal';
import { SupportChatWrapper } from '../SupportChat/SupportChatWrapper';
import { AuthenticationWrapper } from '../../views/Authentication/AuthenticationWrapper';
import { OnboardingWrapper } from '../../views/Onboarding/OnboardingWrapper';
import { ClientToastContainer } from '../ClientToastContainer/ClientToastContainer';
import { PostFormModal } from '../PostForm/PostFormModal';

export const GlobalLayout = ({
  children,
  hideFooter = false,
  disableSupportChat = false,
  siteSubNavigationLinks = undefined,
  hasStickyBottomBanner = false,
  hideStickyBannerGetApp = false,
  stickyBannerGetAppDescription,
  stickyBannerGetAppButtonText,
  stickyBannerGetAppCustomUrl,
}: {
  children: any;
  hideFooter?: boolean;
  disableSupportChat?: boolean;
  hideStickyBannerGetApp?: boolean;
  hasStickyBottomBanner?: boolean;
  siteSubNavigationLinks?: ISiteSubNavLinkItem[];
  stickyBannerGetAppDescription?: string;
  stickyBannerGetAppButtonText?: string;
  stickyBannerGetAppCustomUrl?: string;
}) => {
  return (
    <>
      <Head>
        <meta
          name="apple-itunes-app"
          content="app-id=477967747, app-argument=https://apple.co/3NCzegA"
        />
      </Head>
      <SupportChatWrapper
        hasStickyBottomBanner={hasStickyBottomBanner}
        hideStickyBannerGetApp={hideStickyBannerGetApp}
        disableSupportChat={disableSupportChat}
      />
      <ClientToastContainer />
      <PostFormModal />
      <ConsentModal />
      <AppRedirectModal />
      <div className="bg-white">
        <AuthenticationWrapper />
        <OnboardingWrapper />
        <MainNavigation />
        {siteSubNavigationLinks && <SiteSubNavigation navItems={siteSubNavigationLinks} />}
        {children}
        {!hideStickyBannerGetApp && (
          <StickyBannerGetApp
            buttonText={stickyBannerGetAppButtonText}
            customAppDownloadUrl={stickyBannerGetAppCustomUrl}
            description={stickyBannerGetAppDescription}
          />
        )}
        {!hideFooter && <Footer />}
      </div>
    </>
  );
};
